(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-video-custom"] && !window.DesignMode) return;
  try {
    
    function setVh() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    // Set the value initially
    setVh();

    function setVideoSource() {
      const video = document.querySelector('.responsive-video');
      const source = video.querySelector('source');
      
      if (!source) return; // No source element found
      
      const mobileVideo = video.dataset.videoMobile;
      const desktopVideo = video.dataset.videoDesktop;
      const isMobile = window.innerWidth <= 767;
      
      let newSrc = '';
      
      if (isMobile && mobileVideo) {
        newSrc = mobileVideo;
      } else if (!isMobile && desktopVideo) {
        newSrc = desktopVideo;
      } else {
        // Fallback logic
        newSrc = mobileVideo || desktopVideo;
      }
      
      // Only reload if source is changing
      if (newSrc && source.src !== newSrc) {
        source.src = newSrc;
        video.load();
      }
    }
    
    // Set initial source (in case default needs switching)
    document.addEventListener('DOMContentLoaded', setVideoSource);
    
    // Update on resize
    window.addEventListener('resize', setVideoSource);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-custom"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Splide(".splide", {
    type: "loop",
    perPage: 3,
    perMove: 1,
    focus: "center",
    breakpoints: {
      1440: {
        perPage: 1
      }
    },
    gap: 0,
    pagination: false,
    drag: true
  }).mount();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-testimonials"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoContainers = document.querySelectorAll('.testimonial-slide--video-container');
  let currentlyPlaying = null;

  videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const playButton = container.querySelector('.play-button');
    const placeholder = container.querySelector('.video-placeholder');

    function togglePlay() {
      if (video.paused) {
        // Pause all other videos before playing this one
        if (currentlyPlaying && currentlyPlaying !== video) {
          currentlyPlaying.pause();
        }
        video.play();
        currentlyPlaying = video;
        // Hide the placeholder permanently when video starts playing
        if (placeholder) {
          placeholder.classList.add('hide');
        }
      } else {
        video.pause();
        currentlyPlaying = null;
      }
    }

    function updatePlayButton() {
      playButton.style.display = video.paused ? 'flex' : 'none';
    }

    playButton.addEventListener('click', togglePlay);
    video.addEventListener('click', togglePlay);
    placeholder.addEventListener('click', togglePlay);
    video.addEventListener('play', updatePlayButton);
    video.addEventListener('pause', updatePlayButton);

    // Initial button state
    updatePlayButton();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column-custom"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('custom-drawer');
  const drawerBody = drawer.querySelector('.drawer-custom--body');
  const overlay = document.createElement('div');
  overlay.id = 'drawer-custom-overlay';
  document.body.appendChild(overlay);

  if (!drawer || !drawerBody) {
    console.error('Drawer element not found');
    return;
  }

  const columnItems = Array.from(document.querySelectorAll('.js-column-custom'));
  let currentIndex = 0;

  const handleClick = (index, item) => (e) => {
    e.preventDefault();
    currentIndex = index;
    openDrawerCustom(item);
  };
  
  columnItems.forEach((item, index) => {
    const imageLink = item.querySelector('.text-column__image a');
    const buttonLink = item.querySelector('.text-column__button');
    
    const clickHandler = handleClick(index, item);
  
    if (imageLink) {
      imageLink.addEventListener('click', clickHandler);
    }
    
    if (buttonLink) {
      buttonLink.addEventListener('click', clickHandler);
    }
  });

  function openDrawerCustom(item) {
    const title = item.querySelector('.text-column__title');
    const link = item.querySelector('a');
    
    if (title && link) {
      const titleText = title.textContent;
      const href = link.getAttribute('href');
      
      // Fetch the content from the linked page
      fetch(href)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const rteContent = doc.querySelector('.rte');
          
          if (rteContent) {
            let drawerContent = `
              <div class="drawer-custom--content">
                <h2 class="drawer-custom--title">${titleText}</h2>
                <div class="drawer-custom--description">${rteContent.innerHTML}</div>
              </div>
            `;
            drawerBody.innerHTML = drawerContent;
            drawer.classList.add('open');
            overlay.classList.add('active');
          } else {
            console.error('RTE content not found on the linked page');
          }
        })
        .catch(error => {
          console.error('Error fetching page content:', error);
        });
    } else {
      console.error('Title or link not found in the clicked item');
    }
  }

  function closeDrawerCustom() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
  }

  // Specific event listeners for close button, overlay, and navigation
  const closeButton = drawer.querySelector('.drawer-custom--close');

  if (closeButton) {
    closeButton.addEventListener('click', closeDrawerCustom);
  }

  overlay.addEventListener('click', closeDrawerCustom);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column-ingredients"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('ingredient-drawer');
  const drawerBody = drawer.querySelector('.drawer-custom--body');
  const overlay = document.createElement('div');
  overlay.id = 'drawer-custom-overlay';
  document.body.appendChild(overlay);

  if (!drawer || !drawerBody) {
    console.error('Custom ingredient drawer element not found');
    return;
  }

  const ingredientItems = Array.from(document.querySelectorAll('.grid-item'));
  let currentIndex = 0;

  const handleClick = (index, item) => (e) => {
    e.preventDefault();
    currentIndex = index;
    openDrawerCustom(item);
  };
  
  ingredientItems.forEach((item, index) => {
    const imageLink = item.querySelector('.ingredient--image');
    const titleLink = item.querySelector('.ingredient--title');
    
    const clickHandler = handleClick(index, item);
  
    if (imageLink) {
      imageLink.addEventListener('click', clickHandler);
    }
    
    if (titleLink) {
      titleLink.addEventListener('click', clickHandler);
    }
  });

  function openDrawerCustom(item) {
    const imageUrl = item.getAttribute('data-image');
    const title = item.querySelector('.ingredient--title');
    const amount = item.querySelector('.ingredient--amount');
    const bulletPoints = item.querySelector('.ingredient--bullet-points');

    let drawerContent = `
      <img src="${imageUrl || ''}" alt="${title ? title.textContent : 'Ingredient'}" class="drawer-custom--image">
      <div class="drawer-custom--content">
        <h4 class="drawer-custom--title">${title ? title.textContent : ''}</h4>
        <p class="drawer-custom--amount">${amount ? amount.textContent : ''}</p>
        <div class="drawer-custom--bullet-points">${bulletPoints ? bulletPoints.innerHTML : ''}</div>
      </div>
    `;

    drawerBody.innerHTML = drawerContent;
    drawer.classList.add('open');
    overlay.classList.add('active');
  }

  function closeDrawerCustom() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
  }

  function navigateIngredient(direction) {
    currentIndex = (currentIndex + direction + ingredientItems.length) % ingredientItems.length;
    openDrawerCustom(ingredientItems[currentIndex]);
  }

  // Specific event listeners for close button, overlay, and navigation
  const closeButton = drawer.querySelector('.drawer-custom--close');
  const prevButton = drawer.querySelector('.drawer-custom--prev');
  const nextButton = drawer.querySelector('.drawer-custom--next');

  if (closeButton) {
    closeButton.addEventListener('click', closeDrawerCustom);
  }

  if (prevButton) {
    prevButton.addEventListener('click', () => navigateIngredient(-1));
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => navigateIngredient(1));
  }

  overlay.addEventListener('click', closeDrawerCustom);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
